import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { AnimatePresence, easeInOut, motion } from 'framer-motion';
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';
type OverlayProps = {
  isVisible?: boolean;
  isConfirmation?: boolean;
  className?: string;
};
const Overlay = forwardRef<HTMLDivElement, OverlayProps>((t0, ref) => {
  const $ = _c(7);
  const {
    isVisible,
    isConfirmation: t1,
    className
  } = t0;
  const isConfirmation = t1 === undefined ? false : t1;
  if (!isVisible) {
    return null;
  }
  let t2;
  if ($[0] !== className || $[1] !== isConfirmation || $[2] !== isVisible || $[3] !== ref) {
    t2 = isVisible && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1,
      transition: {
        duration: 0.2,
        ease: easeInOut
      }
    }} exit={{
      opacity: 0,
      transition: {
        duration: 0.15,
        ease: easeInOut
      }
    }} ref={ref} className={cx("fixed inset-0 h-screen w-screen select-none bg-(--overlay-backdrop) backdrop-blur-[2px]", isConfirmation ? "z-confirmation-overlay" : "z-overlay", className)} />;
    $[0] = className;
    $[1] = isConfirmation;
    $[2] = isVisible;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <AnimatePresence>{t2}</AnimatePresence>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
});
export default Overlay;